module.exports = __webpack_public_path__ + "img/八通道超高频读写器.d897936a.jpg";